import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const SubNavBarStyles = styled.div`
  // This bool lets the styled div make the height taller (when a menu is open) to show the dropdown list content.
  height: ${(props) => (props.$isMenuOpen ? '450px' : '60px')};
  overflow-x: scroll;
  overflow-y: visible;
  position: absolute;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  .filters {
    display: flex;
    margin: 0;
    padding: 0 5px;

    .left-scroll,
    .right-scroll {
      position: sticky;
      height: 60px;
      z-index: 8;

      > div {
        position: absolute;
        background-color: #fff;
        height: 59px;
        width: 32px; /* required for background */
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
      }
      svg {
        margin-top: 21px;
        width: 25px;
        height: 25px;
      }
    }

    .left-scroll {
      left: 0;
      > div {
        left: 0;
      }
      svg {
        margin-left: 11px;
      }
    }

    .right-scroll {
      right: 0;
      > div {
        right: 0;
      }
      svg {
        margin-left: 11px;
      }
    }

    .filter {
      padding: 10px 0;
    }

    .studio-logo {
      max-width: 110px;

      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 10px 0 20px;
      svg,
      .logo-hold {
        width: 52px;
        height: 23px;
      }

      filter: invert(1);
    }

    .logo-search-container {
      left: 0;
      display: flex;
      margin-right: auto;
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    display: flex;
    height: 60px;
    justify-content: space-between;
    overflow-x: visible;
    overflow-y: visible;
    position: relative;
    padding: 0;

    .filters {
      width: 100%;
      padding: 0;
      flex-direction: row;
      justify-content: flex-end;
      margin: 0 28px 0 0;

      .left-scroll,
      .right-scroll {
        display: none;
      }
    }
  }
`;
